export const INTRO_SLIDER_ITEMS = [
    'intro-cybersecurity-base-for-everyone',
    'intro-cybersecurity-base',
    'intro-cybersecurity-improve',
    'intro-career-start',
    'intro-management',
    'intro-safer-world',
];
